export enum PreviewTypeEnum {
  READERS = 'readers',
  WOMAN_PERCENT = 'woman_percent',
  MEAN_AGE = 'mean_age',
  AVG_BOOK_BY_READER = 'avg_book_by_reader',
  TOTAL_BOOK = 'total_books',
}
